const APPROVAL = 'approval'
const CONTRACT_SENT = 'contract-sent'
const DOCS = 'docs'
const EMISSION = 'emission'
const EMPTY = '-'
const INCOME = 'income'
const NEW_CONTRACT = 'new-contract'
const RELEASE = 'release'

const SEND_CONTRACT_TASK_ORDER = 60

const processPipelineStatus = (t, pipelineStatus, incompleteTaskOrder) => {
  switch (pipelineStatus) {
    case undefined:
      return EMPTY
    case 'Contrato':
      if (incompleteTaskOrder <= SEND_CONTRACT_TASK_ORDER) {
        return t(`table.body.${NEW_CONTRACT}`)
      }
      return t(`table.body.${CONTRACT_SENT}`)
    default:
      return pipelineStatus
  }
}

export {
  APPROVAL,
  CONTRACT_SENT,
  DOCS,
  EMISSION,
  EMPTY,
  INCOME,
  NEW_CONTRACT,
  RELEASE,
  processPipelineStatus,
}
